import React from "react";
import { Table } from "react-bootstrap";
import useTime from "../../../hooks/useTime";

const HistoryTables = ({ data }) => {
    const { convertDate } = useTime();

    return (
        <Table responsive="sm"
            className="custom-table-3"
        >
            <thead>
                <tr>
                    <th className="text-start">Period</th>
                    <th className="text-center">Count</th>
                    <th className="text-end">Amount</th>
                </tr>
            </thead>
            <tbody>
                {
                    (data) &&
                    data?.map((item, index) =>
                        <tr key={item?.id || index}>
                            <td className="text-start align-middle">
                                {convertDate(item?.from_date)} - {convertDate(item?.to_date)}
                            </td>
                            <td className="text-center align-middle">{item?.level?.category_limit}</td>
                            <td className="text-end align-middle">{(+item?.receiver_amount).toFixed(2)}</td>
                        </tr>
                    )
                }
            </tbody>
        </Table>
    );
};

export default HistoryTables;